import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

import noop from 'lodash/noop';

/**
 * Use this hook to auto subscribe to any property changes. i.e. You want to
 * subscribe to app state change, then use this hook with AppManager,
 * so any changes on app state will be broadcasted to the component.
 */
function useUpdate(fn: EffectCallback, keys?: DependencyList) {
  const mount = useRef(false);

  useEffect(() => {
    if (!mount.current) {
      mount.current = true;
    } else {
      return fn();
    }

    return noop;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, keys);
}

export { useUpdate };
